module.exports = __webpack_public_path__ + "static/media/conagra-logo-mobile.c5cd75cf.png";